module.exports = __webpack_public_path__ + "static/img/full1_33.96866ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/full1_33.png
// module id = 3T27
// module chunks = 3